import Vue from 'vue';
import gaService from './ga.service';

export default {
  async openSession(gameId, language, isMobile) {
    gaService.send('games', 'galaxsys', gameId);
    return (await Vue.http.post('/api/galaxsys/session/open', { gameId, language, isMobile })).data;
  },
  async openDemoSession(gameId, language, isMobile) {
    gaService.send('games-demo', 'galaxsys', gameId);
    return (await Vue.http.post('/api/galaxsys/session/opendemo', { gameId, language, isMobile })).data;
  },
  async closeSession() {
    return (await Vue.http.post('/api/galaxsys/session/close')).data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/galaxsys.service.js